import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./theme/ThemeProvider";
import { SessionProvider } from "./lib/SessionContext";
import {
  initSentry,
  initPostHogIfConsented,
  ErrorBoundary,
} from "./lib/observability";
import { App } from "./App";

initSentry();
// Returning visitors who already accepted: load PostHog before render.
// First-time / rejected visitors load nothing until they accept.
initPostHogIfConsented();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary fallback={<div className="center muted">Something went wrong.</div>}>
      <ThemeProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
